import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconCapitalLetterL = SvgIcon({
    children: jsx("path", { d: "M11.22 14.68V7.6H9.84V16H14.64V14.68H11.22Z" }),
});

export { IconCapitalLetterL };
